import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from "../../shared/services/auth.service";
import {ProfileService} from "../../shared/services/profile.service";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss'],
  imports: [MaterialModule, FormsModule],
  standalone: true,
})
export class EmailDialogComponent implements OnInit {
  user: any = null;
  email: any = {};

  customEmail = {
    subject: 'Custom Model Purchase ',
    message: '...'
  };

  indexEmail = {
    subject: 'Purchase Index ',
    message: '...'
  };

  constructor(
    public dialogRef: MatDialogRef<EmailDialogComponent>,
    private service: ProfileService,
    private auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
    if (this.data.type === 'index') {
      // we have index details in data
      this.email = this.indexEmail;
    } else {
      this.email = this.customEmail;
    }

    // Fetch user data for email
    this.auth.getCurrentUser().subscribe(resp => {
      if (resp.id) {
        this.user = resp;
      }
    });
  }

  onSubmit(): void {

    if (this.data.type === 'index') {
      this.email.index_id = this.data.index ? this.data.index.id : null;
    }

    this.service.purchase(this.email, this.data.type).subscribe( (resp: any) => {
      if (resp === true) {
        this.service.notificationService.open('Mail sent');
      }
      this.dialogRef.close(true);
    });
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close();
  }

}
